
export default {
  name: "QdapHomeQuestionnaireOption",
  props: {
    data: {
      type: Array,
      default: () => {},
    },
    selectedValue: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      selectedOptionValue: '',
      getActiveOption: '',
    }
  },
  computed: {
  },
  mounted() {
    if ( this.selectedValue ) {
      this.getActiveOption = this.selectedValue;
    }
  },
  methods: {
    selectItem(selectedText, selectedIndex) {
      // console.debug('option selected value -', selectedText);
      this.selectedOptionValue = { text: selectedText, value: selectedIndex};
      this.getActiveOption = selectedIndex;
      this.$emit('update-selected', { text: selectedText, value: selectedIndex});
    }
  }
}
